import React from 'react';
import Table from 'react-bootstrap/Table';
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';
//import Table from '@material-ui/core/Table';

import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DropDown from './DropDown';
import OrderIcon from './OrderIcon';
import moment from 'moment';
import Swal from 'sweetalert2';

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  headerBacke: {
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.125)',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  conf: {
    border: '0',
    borderRadius: '.25em',
    background: 'initial',
    backgroundColor: '#e64942',
    color: '#fff',
    fontSize: '1.0625em',
    margin: '.3125em',
    padding: '.625em 1.1em',
    boxShadow: 'none',
  },
  yesConfirm: {
    backgroundColor: '#e3342f !important',
    fontSize: '13px !important',
    fontWeight: 400,
    paddingTop: '12px',
    paddingLeft: '11px',
    paddingRight: '11px',
    paddingBottom: '9px',
    borderColor: '#e3342f !important',
  },
  noCancel: {
    backgroundColor: '#888',
    fontSize: '13px !important',
    fontWeight: 400,
    paddingTop: '12px',
    paddingLeft: '11px',
    paddingRight: '11px',
    paddingBottom: '9px',
  },
});

interface TableI {
  data: any[];
  depData: any[];
  setClickData: (e: any) => void;
  setEditOpen: (e: boolean) => void;

  fdate: Date;
  tdate: Date;
  printnow: boolean;
  setprintnow: (e: boolean) => void;
  // arrangeData: (e: any) => void;
  setSorting: (obj: { orderName: string; order_by: string }) => void;
  pageNumber: number;
  sorting: {
    orderName: string;
    order_by: string;
  };
  checked: boolean;
  //bulkDel: (a: any) => void;
  getData: (e: any) => void;
  setLoad: (b: boolean) => void;
  deleteData: (e: number) => void;

  colHeaders: ColHeaders[];
  newaction: boolean;
  setColHeaders: (c: ColHeaders[]) => void;
  status: string;
}

interface ColHeaders {
  id: string;
  description: string;
  value: string;
  active: boolean;
}

const Tables: React.FC<TableI> = ({
  data,
  depData,
  sorting,
  printnow,
  newaction,
  pageNumber,
  setEditOpen,
  // checked,
  setClickData,
  setLoad,
  setprintnow,
  getData,
  setSorting,
  fdate,
  tdate,
  deleteData,
  status,
  colHeaders,
  setColHeaders,
}) => {
  const [sorted, setsorted] = React.useState<boolean>(true);
  const [reArranged, setArranged] = React.useState([]);
  const [TableData, setTableData] = React.useState(data);
  const [checked, setChecked] = React.useState(false);

  const [mount, setMount] = React.useState(false);
  // console.log(TableData,"table Data")

  //function to adding the index
  // console.log(data ,"data table")
  // console.log(TableData, "Table Data 2")

  var arrayLength = TableData.length;
  for (var i = 0; i < arrayLength; i++) {
    //console.log('do Something')
    TableData[i].id = i + 1;
  }

  const sort = (e: string) => {
    if (sorted === true) {
      if (sorting.orderName === e && sorting.order_by === 'asc') {
        setSorting({
          orderName: e,
          order_by: 'desc',
        });
        setsorted(false);
      } else {
        setsorted(true);
        setSorting({
          orderName: e,
          order_by: 'asc',
        });
      }
    } else {
      setsorted(true);
      setSorting({
        orderName: e,
        order_by: 'asc',
      });
    }
  };
  const classes = useStyles();

  const inputEl = React.useRef([]);

  const print = React.useCallback(() => {
    if (data.length < 1) {
      Swal.fire({
        icon: 'error',
        title: 'Nothing To Print',
        text: 'No Records to Print',
      });
    } else {
      var fd = moment(fdate).format('YYYY-MM-DD');
      var td = moment(tdate).format('YYYY-MM-DD');
      var divContents = document.getElementById('printMe').innerHTML;
      var a = window.open('', '', 'height=900, width=600');
      a.document.write('<html>');
      a.document.write(
        '<body > <h4>Exeption Report -Range:<br>' + fd + ' to' + td,
      );
      a.document.write(divContents);
      a.document.write('</body></html>');
      a.document.close();
      a.print();
      a.close();
      // window.onafterprint = function() {};
    }
  }, [fdate, data, tdate]);

  const toggleHandler = (value, id) => {
    let newState = [...TableData];
    if (value) {
      newState[id].activated = 1;
      setArranged([...newState]);
      setTableData([...newState]);
    } else {
      newState[id].activated = 0;
      setArranged([...newState]);
      setTableData([...newState]);
    }
    // let Active = [...newState];
    // Active = newState.filter(r => r.activated === 1);
    // // setDeldata([...Active]);
    // //bulkDel([...Active]);
  };
  const handleDragStart = (e: React.DragEvent<HTMLTableDataCellElement>) => {
    const { id } = e.currentTarget;
    const idx = colHeaders.findIndex((ida: ColHeaders) => ida.id === id);
    e.dataTransfer.setData('colIdx', idx.toString());
  };
  const handleDragOver = (e: React.DragEvent<HTMLTableDataCellElement>) =>
    e.preventDefault();

  const handleOnDrop = (e: React.DragEvent<HTMLTableDataCellElement>) => {
    const { id } = e.currentTarget;
    const droppedColIdx = colHeaders.findIndex(
      (ida: ColHeaders) => ida.id === id,
    );
    const draggedColIdx = e.dataTransfer.getData('colIdx');
    const tempCols = [...colHeaders];

    tempCols[parseInt(draggedColIdx)] = colHeaders[droppedColIdx];
    tempCols[droppedColIdx] = colHeaders[parseInt(draggedColIdx)];
    setColHeaders(tempCols);
  };

  const selectAll = React.useCallback(
    (e: boolean) => {
      if (e) {
        let array = [];
        for (const check of data) {
          let ob = { ...check };
          ob.activated = 1;
          array.push(ob);
          setArranged([...array]);
          //bulkDel([...array]);
          setTableData([...array]);
        }
      } else {
        let array = [];
        for (const check of data) {
          let ob = { ...check };
          ob.activated = 0;
          array.push(ob);
          setArranged([...array]);
          // bulkDel([...array]);
          setTableData([...array]);
        }
        // let Active = [];
        // Active = array.filter(r => r.activated === 1);
        // setDeldata([...Active]);
        // bulkDel([...Active]);
      }
    },
    [data, setArranged],
  );

  React.useEffect(() => {
    selectAll(checked);
  }, [checked, selectAll]);

  React.useEffect(() => {
    if (!mount) {
      // collection();
      setArranged(reArranged);
      // arrangeData(reArranged);
    }

    setMount(true);
  }, [reArranged, setLoad, mount, data]);

  React.useEffect(() => {
    if (printnow) {
      print();
      setprintnow(false);
    }
  }, [print, printnow, setprintnow]);
  //console.log(colHeaders ,"col header")
  return (
    <div>
      {data.length < 1 || newaction === true ? (
        <div>
          <TableContainer style={{ paddingBottom: '60px' }}>
            <hr />
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    style={{
                      fontSize: '14px',
                      width: '10%',
                    }}></StyledTableCell>
                  {colHeaders.map((d: ColHeaders, k: number) => (
                    <StyledTableCell
                      onClick={() => sort(d.value)}
                      draggable
                      style={{ fontSize: '14px' }}
                      key={d.id}
                      id={d.id}
                      onDragStart={handleDragStart}
                      onDragOver={handleDragOver}
                      onDrop={handleOnDrop}>
                      <b>{d.description}</b>
                      {sorting.orderName === d.value ? (
                        <OrderIcon order_by={sorting.order_by} />
                      ) : (
                        ''
                      )}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody></TableBody>
            </Table>
            <div>
              <br></br>
              <br></br>
              <h4>No Data</h4>
              <br></br>
              <br></br>
            </div>
          </TableContainer>
        </div>
      ) : (
        <div id={'printMe'}>
          <Table responsive>
            <thead>
              <tr>
                {printnow === false ? (
                  <td
                    style={{
                      minWidth: '50px',
                    }}>
                    <input
                      type="Checkbox"
                      style={{ width: ' 19px', height: '19px' }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setChecked(!checked)
                      }
                      checked={checked}
                    />
                  </td>
                ) : null}

                {colHeaders.map((d: ColHeaders, k: number) => (
                  <StyledTableCell
                    onClick={() => sort(d.value)}
                    draggable
                    style={{ fontSize: '14px' }}
                    key={d.id}
                    id={d.id}
                    onDragStart={handleDragStart}
                    onDragOver={handleDragOver}
                    onDrop={handleOnDrop}>
                    <b>{d.description}</b>
                    {sorting.orderName === d.value ? (
                      <OrderIcon order_by={sorting.order_by} />
                    ) : (
                      ''
                    )}
                  </StyledTableCell>
                ))}
                {printnow === false ? (
                  <StyledTableCell style={{ fontSize: '14px' }}>
                    <b>Actions</b>
                  </StyledTableCell>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {TableData &&
                TableData.map((row, key) => (
                  <tr key={key}>
                    {printnow === false ? (
                      <td style={{ minWidth: '50px' }}>
                        {
                          <input
                            type="Checkbox"
                            style={{ width: ' 19px', height: '19px' }}
                            id={'input' + TableData[key].rno + key}
                            ref={ref =>
                              inputEl.current.push(TableData[key].rno)
                            }
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>,
                            ) => toggleHandler(e.target.checked, key)}
                            checked={
                              TableData[key].activated === 1 ? true : false
                            }
                          />
                        }
                      </td>
                    ) : null}

                    {colHeaders.map((he, index) => (
                      <StyledTableCell key={index} style={{ fontSize: '14px' }}>
                        {he.value === 'invoiceId' ? (
                          // eslint-disable-next-line
                          <a
                            href="#"
                            onClick={() => {
                              setClickData(row);
                              setEditOpen(true);
                            }}>
                            {row[he.value]}
                          </a>
                        ) : (
                          row[he.value]
                        )}
                      </StyledTableCell>
                    ))}
                    {printnow === false ? (
                      <StyledTableCell style={{ minWidth: '50px' }}>
                        {row.status !== 0 ? (
                          <div style={{ display: 'flex' }}>
                            {/* <div className="eye-icon p-2">
                              <i className="fas fa-eye"></i>
                            </div> */}
                            <div>
                              <DropDown
                                depData={depData}
                                setClickData={setClickData}
                                setEditOpen={setEditOpen}
                                row={row}
                                status={status}
                                deleteData={deleteData}
                                //update data
                                setLoad={setLoad}
                              />
                            </div>
                          </div>
                        ) : null}
                      </StyledTableCell>
                    ) : null}
                  </tr>
                ))}
            </tbody>
            <br></br>
            <br></br>
            <br></br>
          </Table>
        </div>
      )}
    </div>
  );
};

export default React.memo(Tables);
